import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AuthForm from '../AuthForm'
import TextField from '../../../../Components/GeneralComponents/TextField'
import { ButtonOutline } from '../../../../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import errorToast from '../../../../Components/Toasts/ErrorToast'
import { validateBothPasswords } from '../../../../Helpers/passwordValidations'
import { updatePassword } from 'firebase/auth'
import { useAuth } from '../../../../Contexts/AuthContext'
import PropType from 'prop-types'
const SetUpPasswordForm = ({ user }) => {
  const { loginWithEmail } = useAuth()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  })

  const handleChange = event => {
    const { name, value } = event.target
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async event => {
    event.preventDefault()
    const { password, confirmPassword } = formData
    const { error } = validateBothPasswords(password, confirmPassword)

    if (error) {
      errorToast(error)
      return
    }

    try {
      await updatePassword(user, password)
      const idToken = await user.getIdToken(true)
      await loginWithEmail(idToken)
    } catch (err) {
      errorToast(err.message)
      navigate('/login')
    }
  }

  return (
    <AuthForm title={'Set Up Account'} onSubmit={handleSubmit}>
      <TextField
        label={'Password'}
        placeholder={'Enter password'}
        onChange={handleChange}
        value={formData.password}
        name="password"
        type="password"
        id="password"
      />
      <TextField
        label={'Confirm password'}
        placeholder={'Enter password'}
        onChange={handleChange}
        value={formData.confirmPassword}
        name="confirmPassword"
        type="password"
        id="confirmPassword"
      />
      <ButtonOutline type="submit" color="pink" text="Continue" />
    </AuthForm>
  )
}

SetUpPasswordForm.propTypes = {
  user: PropType.object,
}

export default SetUpPasswordForm
